module.exports = __webpack_public_path__ + "static/GimletXRay-VF-e38f0affb469d93f0754fe8eb451a265.woff";